import { formatMoney, getMaxMinValueList } from "Helpers/helpFunction";
import moment from "moment";

export const options = (data: any, CommnonStore: any) => {
  let fontSize = '14px'
  let height = 230
  if (CommnonStore?.innerWidthScreen < 1500) {
    height = 220;
    fontSize = '10px'
  }

  const totalLength = data?.tradingDate ? (data?.tradingDate.length / 5) : 0

  const priceNow = data?.price?.[data?.price.length - 1]
  const stockValuation = data?.stockValuation
  let min = data?.price?.[0]
  let max = data?.price?.[0]
  min = getMaxMinValueList(data?.price, min, max)?.min
  max = getMaxMinValueList(data?.price, min, max)?.max
  if (data?.sellZone && data?.sellZone > 0) {
    min = getMaxMinValueList([data?.sellZone], min, max)?.min
    max = getMaxMinValueList([data?.sellZone], min, max)?.max
  }

  if (data?.buyZone && data?.buyZone > 0) {
    min = getMaxMinValueList([data?.buyZone], min, max)?.min
    max = getMaxMinValueList([data?.buyZone], min, max)?.max
  }

  let priceAlign = 'right'
  let valuationAlign = 'right'
  const Valuation10PercentPlus = stockValuation + stockValuation * 0.1
  const Valuation10PercentMinus = stockValuation - stockValuation * 0.1
  if (Valuation10PercentMinus < priceNow && priceNow < Valuation10PercentPlus) {
    priceAlign = 'right'
    valuationAlign = 'center'
  }

  let plotBands: any = []
  if (data?.averagePe1y > 0 || data?.averagePb1y > 0 || data?.average1y > 0) {
    plotBands = [{
      to: data?.sellZone * 2,
      from: data?.trackingZone,
      color: '#50202b',
    }, {
      to: data?.trackingZone,
      from: data?.stockValuation,
      color: '#514219',
    }, {
      to: data?.stockValuation,
      from: data?.buyZone,
      color: '#3c571b',
    }, {
      to: data?.buyZone,
      from: min / 2,
      color: '#233d21',
    }]
  } else {
    plotBands = [{
      to: 5000,
      from: 0,
      color: '#c5c5c530',
    }]
  }

  let yAxisValue: any = {
    // min: 30,
    min: min,
    max: max,
    tickInterval: 5,
    title: {
      text: ''
    },
    gridLineWidth: 0,
    minorTickWidth: 0,
    labels: {
      style: {
        color: '#ffffff',
        fontSize: fontSize
      },
      formatter: function (res: any) {
        return res?.value ? formatMoney(res?.value, 2) : '';
      }
    },
    plotBands: plotBands,
    plotLines: [{
      color: '#11cabe',
      width: 2,
      dashStyle: 'ShortDot',
      value: priceNow,
      zIndex: 1111111,
      label: {
        x: -10,
        align: priceAlign,
        style: {
          color: '#edff00',
          fontFamily: `Inter`,
          backgroundColor: '#e4e4e43d',
          paddingRight: 12
        },
        text: `Giá hiện tại ${formatMoney(priceNow, 2)}`,
        textAlign: 'right',
        useHTML: ' false',
        verticalAlign: 'top',
      }
    }, {
      color: '#11cabe',
      width: 2,
      dashStyle: 'ShortDot',
      value: stockValuation,
      zIndex: 1111111,
      label: {
        x: -10,
        align: valuationAlign,
        style: {
          color: '#edff00',
          fontFamily: `Inter`,
          backgroundColor: '#e4e4e43d'
        },
        text: `Định giá ${formatMoney(stockValuation, 2)}`,
        textAlign: 'right',
        useHTML: ' false',
        verticalAlign: 'top',
      }
    }],
  }

  // if (valueTop) {
  //   yAxisValue.max = valueTop;
  // }

  return {
    chart: {
      type: 'spline',
      defaultSeriesType: 'spline',
      backgroundColor: 'transparent',
      height: height,
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    xAxis: {
      categories: data?.tradingDate,
      tickInterval: totalLength,
      title: {
        text: ''
      },
      lineColor: 'transparent',
      labels: {
        style: {
          color: '#ffffff',
          fontSize: fontSize
        },
        enabled: true,
        formatter: function (res: any) {
          return res?.value ? moment(res?.value, 'DD/MM').format('DD/MM') : '';
        }
      },

      crosshair: {
        color: '#ff0000',
        dashStyle: 'Solid',
        snap: true,
        width: 2,
        className: 'esrpuelfux'
      }
    },
    yAxis: yAxisValue,
    legend: {
      enabled: false
    },
    plotOptions: {

    },
    tooltip: {
      enabled: true,
      useHTML: true,
      // split: true,
      formatter: function () {
        const thisData: any = this

        return `<span>
        <div>Ngày: ${moment(thisData?.x, 'DD/MM/YYYY').format('DD/MM')}</div>
        <div>Giá: ${formatMoney(thisData?.y, 2)} </div>
        </span>`;
      }
    },
    series: [{
      name: 'test1',
      lineColor: '#2AD03D',
      lineWidth: 1.3,
      marker: {
        radius: 0,
        enable: false,
      },
      data: data?.price
    }]
  }
}